export const dict = {
    lobby: {
        headerModerator: 'Invite players to the room',
        headerUser: 'Waiting for the moderator to start the session',
        sendLinkInstructions:
            'Send the link below to your team mates and soon they will start joining the room',
        nameSessionTickets: 'Name session tickets',
        startEstimating: 'Start estimating',
        ticketDescriptionPlaceholder: 'New ticket description',
    },
    homepage: {
        header: 'Create your planning room.',
        subtitle:
            'A simple online planning poker for fast and clear team estimates.',
        name: {
            placeholder: 'Write your nickname',
        },
        benefits: {
            title: 'Benefits',
            line1: 'No registration required',
            line2: 'Share one link with your team',
            line3: 'Works on desktop and mobile',
        },
        howItWorks: {
            title: 'How it works',
            step1: {
                title: '01 Create a room',
                subtitle: 'Enter your name and get a private room instantly.',
            },
            step2: {
                title: '02 Invite your team',
                subtitle: 'Share a single link to join.',
            },
            step3: {
                title: '03 Estimate together',
                subtitle: 'Pick cards, vote, reveal, repeat.',
            },
        },
        createSessionButton: 'Create session',
        joinSessionButton: 'Or join existing room',
        createAccount: {
            title: 'Create free account',
            description: 'Save history of pointing poker sessions.',
            loginRegister: 'Login / Register',
        },
    },
    join: {
        header: 'Join the planning poker room:',
        name: {
            label: 'Please enter your name to start',
            placeholder: 'Write your nickname',
        },
        joinButton: 'Join room',
    },
    login: {
        title: 'Login with email',
        email: {
            label: 'Email',
            placeholder: 'Your login email',
        },
        password: {
            label: 'Password',
            placeholder: 'Your password',
        },
        loginButton: 'Continue with email',
        separator: 'or Log in with',
        disclaimer:
            'By continuing you agree Taskez’s Terms of Services & Privacy Policy ',
        registerButton: 'Register new account',
        forgotPasswordButton: 'I forgot my password',
    },
    header: {
        jobs: 'Jobs',
        about: 'About',
        createRoom: 'Create room',
        joinRoom: 'Join room',
        loginRegister: 'Login / Register',
    },
    playersBox: {
        header: 'Players in room 🕹️',
        moderatorSubtitle: 'Moderator',
        ready: 'Ready',
        waiting: 'Waiting',
        offline: 'Offline',
        you: 'You',
    },
    resultsTable: {
        header: 'Results 🕹️',
        votingTime: 'Voting time',
        averageVote: 'Average vote',
    },
    poweredBy: {
        start: 'Powered by ',
        end: 'www.devcity.tech',
    },
    voting: {
        header: 'Session #{{ sessionNumber }}',
        nowVotingWithName: 'Now voting: {{ ticketName }}',
        nowVotingWithoutName: 'Now voting',
        showVotingHistory: 'Show voting history',
        endSession: 'End session',
        voteButtonsLabel: 'Vote your choice',
        revealButton: 'Reveal estimation',
        readyButton: {
            notReady: 'Set ready for next vote',
            ready: 'Ready for next vote',
        },
        waitingForModerator:
            'Waiting for the moderator to continue session or repeat voting',
        voteAgain: 'Vote again',
        startNewEstimation: 'Start new estimation',
    },
    votingHistory: {
        tagline: 'Session #{{ sessionNumber }} history 👇',
        ticketDescriptionPlaceholder: 'No name ticket',
    },
    sessionEndModal: {
        header: 'Are you sure you want to end the session?',
        endSessionButton: 'End Session',
    },
    sessionEndPage: {
        sessionWasEnded: 'Session #{{ sessionNumber }} was ended',
        createNewSession: 'Create new session',
    },
    generic: {
        cancel: 'Cancel',
    },
    register: {
        header: 'New account',
        emailTitle: 'Email',
        emailPlaceholder: 'Your login email',
        passwordTitle: 'Password',
        passwordPlaceholder: 'Your password',
        repeatPasswordTitle: 'Repeat password',
        repeatPasswordPlaceholder: 'Your password',
        acceptTermsText: 'I accept the terms and conditions',
        createAccount: 'Create account',
        passwordsDoNotMatch: 'Passwords do not match',
        termsNotAccepted: 'You need to accept the terms and conditions',
    },
};
